import { ChangeEvent, ReactNode } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { cn } from "@verse_core/shared_components/ClassName";

type LoginCardInputProps = {
  icon: IconDefinition;
  type: "text" | "password";
  placeholder: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  id: string;
  readOnly?: boolean;
  autoFocus?: boolean;
  hasError?: boolean;
  trailing?: ReactNode;
};

/** Text field for the login card: leading icon, optional trailing control. */
export const LoginCardInput = ({
  icon,
  type,
  placeholder,
  value,
  onChange,
  id,
  readOnly = false,
  autoFocus = false,
  hasError = false,
  trailing,
}: LoginCardInputProps) => (
  <div
    className={cn(
      "tw-flex tw-h-[48px] tw-w-full tw-items-center tw-justify-between tw-gap-[8px] tw-overflow-hidden tw-rounded-[4px] tw-border tw-border-solid tw-p-[10px]",
      readOnly ? "tw-bg-verse-surface-secondary" : "tw-bg-white",
      hasError
        ? "tw-border-verse-border-critical"
        : "tw-border-verse-border-secondary",
    )}
  >
    <div className="tw-flex tw-min-w-0 tw-flex-grow tw-items-center tw-gap-[8px]">
      <FontAwesomeIcon
        icon={icon}
        className={cn(
          "tw-h-[16px] tw-w-[16px] tw-shrink-0",
          readOnly
            ? "tw-text-verse-icon-disabled"
            : "tw-text-verse-icon-primary",
        )}
      />
      <input
        id={id}
        type={type}
        aria-label={placeholder}
        className="tw-w-full tw-min-w-0 tw-border-none tw-bg-transparent tw-p-0 tw-font-sans tw-text-[14px] tw-font-medium tw-text-verse-text-primary tw-outline-none placeholder:tw-text-verse-text-disabled"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        autoFocus={autoFocus}
      />
    </div>
    {trailing}
  </div>
);
